document.addEventListener("DOMContentLoaded", function() {
  
    gsap.registerPlugin(ScrollTrigger);

    // Select all images with the 'blur-on-scroll' class
    const images = document.querySelectorAll('.blur-on-scroll img');

    images.forEach((img) => {
        // Set initial blur using CSS filter
        gsap.set(img, { filter: "blur(10px)" });

        // ScrollTrigger for each image
        gsap.to(img, {
            filter: "blur(0px)", // Reveal the image
            scrollTrigger: {
                trigger: img, // Trigger the animation when the image enters the viewport
                start: "top 90%", // When the top of the image is 80% from the top of the viewport
                end: "top 50%", // When the top of the image reaches 20% from the top of the viewport
                scrub: true // Smooth scrolling effect
            }
        });
    });

  
/*
ScrollTrigger.create({
   
   trigger: 'div.bg_black',
   start:"top 80%",
   end:"bottom 0%", 
 
   onEnter: () => {
     gsap.to('body', { duration: 1.0, backgroundColor: 'white'})
   },
   
   onEnterBack: () => {
     gsap.to('body', { duration: 1.0, backgroundColor: 'white'})
   },
    
 })

ScrollTrigger.create({

   trigger: 'div.bg_blackfooter',
   start:"top 80%",
   end:"bottom 0%", 
 
   onEnter: () => {
     gsap.to('body', { duration: 1.0, backgroundColor: 'black', color:'white'})
   },
   
   onEnterBack: () => {
     gsap.to('body', { duration: 1.0, backgroundColor: 'black', color:'white'})
   },
    
 })
 
 ScrollTrigger.create({
   
   trigger: 'div.bg_beige',
   start:"top 80%",
   end:"bottom 20%", 
 
   onEnter: () => {
     gsap.to('body', { duration: 1.0, backgroundColor: '#FEFDF5'})
   },
   
   onEnterBack: () => {
     gsap.to('body', { duration: 1.0, backgroundColor: '#FEFDF5'})
   },
 
 })

   ScrollTrigger.create({
   
   trigger: 'div.bg_beige2',
   start:"top 80%",
   end:"bottom 20%", 
 
   onEnter: () => {
     gsap.to('body', { duration: 1.0, backgroundColor: '#FEFDF5'})
   },
   
   onEnterBack: () => {
     gsap.to('body', { duration: 1.0, backgroundColor: '#FEFDF5'})
   },
 
 })

   ScrollTrigger.create({
   
   trigger: 'div.bg_darkbeige',
   start:"top 80%",
   end:"bottom 20%", 
 
   onEnter: () => {
     gsap.to('body', { duration: 1.0, backgroundColor: '#E3E1D7'})
   },
   
   onEnterBack: () => {
     gsap.to('body', { duration: 1.0, backgroundColor: '#E3E1D7'})
   },
 
 })

  */

});

/*

document.addEventListener("DOMContentLoaded", function() {
    const header = document.querySelector("sticky-header"); // Adjust the selector to match your header

    ScrollTrigger.create({
        start: 0,
        end: "max",
        onUpdate: (self) => {
            let currentScroll = window.pageYOffset;

            // Change background color to solid when scrolled down
            if (currentScroll > 300) {
                gsap.to(header, { backgroundColor: "rgba(254, 253, 245, 1)", duration: 0.3 }); // Solid background
            }

            // Gradually make the background transparent when user scrolls back to top
            if (currentScroll <= 5) {
                gsap.to(header, { backgroundColor: "rgba(254, 253, 245, 0)", duration: 0.3 }); // Transparent background
            }
        }
    });
});

*/
